import React from 'react';
import Loadable from 'react-loadable'

import DefaultLayout from './containers/DefaultLayout';
import ImportProduct from './views/Products/ImportProduct';

function Loading() {
  return <div>Loading...</div>;
}

const Dashboard = Loadable({
  loader: () => import('./views/Dashboard'),
  loading: Loading,
});

const Profile = Loadable({
  loader: () => import('./views/Profile'),
  loading: Loading,
});

const EmailTemplates = Loadable({
  loader: () => import('./views/EmailTemplates/EmailTemplates'),
  loading: Loading,
});

const EditEmailTemplate = Loadable({
  loader: () => import('./views/EmailTemplates/EditEmailTemplate'),
  loading: Loading,
});

const ViewEmailTemplate = Loadable({
  loader: () => import('./views/EmailTemplates/ViewEmailTemplate'),
  loading: Loading,
});
const Contents = Loadable({
  loader: () => import('./views/Contents/Contents'),
  loading: Loading,
});

const EditContent = Loadable({
  loader: () => import('./views/Contents/EditContent'),
  loading: Loading,
});

const CarCategories = Loadable({
  loader: () => import('./views/CarCategories/Categories'),
  loading: Loading,
});

const AddCarCategory = Loadable({
  loader: () => import('./views/CarCategories/AddCategory'),
  loading: Loading,
});

const EditCarCategory = Loadable({
  loader: () => import('./views/CarCategories/EditCategory'),
  loading: Loading,
});

const CarBrands = Loadable({
  loader: () => import('./views/CarBrand/Brands'),
  loading: Loading,
});

const AddCarBrand = Loadable({
  loader: () => import('./views/CarBrand/AddBrand'),
  loading: Loading,
});

const EditCarBrand = Loadable({
  loader: () => import('./views/CarBrand/EditBrand'),
  loading: Loading,
});

const CarSells = Loadable({
  loader: () => import('./views/CarSells/CarSells'),
  loading: Loading,
});

const ViewCarSells = Loadable({
  loader: () => import('./views/CarSells/View'),
  loading: Loading,
});
const AddCarSells = Loadable({
  loader: () => import('./views/CarSells/addCarSeller'),
  loading: Loading,
});
const EditCarSells = Loadable({
  loader: () => import('./views/CarSells/editSellCar'),
  loading: Loading,
});
const ViewCarSellsData = Loadable({
  loader: () => import('./views/CarSells/viewCar'),
  loading: Loading,
});

const SellProducts = Loadable({
  loader: () => import('./views/SellProducts/SellProducts'),
  loading: Loading,
});

const ViewSellProducts = Loadable({
  loader: () => import('./views/SellProducts/View'),
  loading: Loading,
});
const AddProductseller = Loadable({
  loader: () => import('./views/SellProducts/addSellerProduct'),
  loading: Loading,
});
const EditSellProduct = Loadable({
  loader: () => import('./views/SellProducts/editSellerProduct'),
  loading: Loading,
});

const CarModels = Loadable({
  loader: () => import('./views/CarModel/Models'),
  loading: Loading,
});

const AddCarModel = Loadable({
  loader: () => import('./views/CarModel/AddModel'),
  loading: Loading,
});

const EditCarModel = Loadable({
  loader: () => import('./views/CarModel/EditModel'),
  loading: Loading,
});

const CarLists = Loadable({
  loader: () => import('./views/CarList/Cars'),
  loading: Loading,
});

const AddCar = Loadable({
  loader: () => import('./views/CarList/AddCar'),
  loading: Loading,
});

const EditCar = Loadable({
  loader: () => import('./views/CarList/EditCar'),
  loading: Loading,
});

const ImportCar = Loadable({
  loader: () => import('./views/CarList/ImportCar'),
  loading: Loading,
});

const ColorList = Loadable({
  loader: () => import('./views/Color/Color'),
  loading: Loading,
});

const AddColor = Loadable({
  loader: () => import('./views/Color/AddColor'),
  loading: Loading,
});

const EditColor = Loadable({
  loader: () => import('./views/Color/EditColor'),
  loading: Loading,
});

const Categories = Loadable({
  loader: () => import('./views/Categories/Categories'),
  loading: Loading,
});

const AddCategory = Loadable({
  loader: () => import('./views/Categories/AddCategory'),
  loading: Loading,
});

const EditCategory = Loadable({
  loader: () => import('./views/Categories/EditCategory'),
  loading: Loading,
});


const Occasions = Loadable({
  loader: () => import('./views/Occasions/Occasions'),
  loading: Loading,
});

const AddOccasion = Loadable({
  loader: () => import('./views/Occasions/AddOccasion'),
  loading: Loading,
});

const EditOccasion = Loadable({
  loader: () => import('./views/Occasions/EditOccasion'),
  loading: Loading,
});

const SubCategories = Loadable({
  loader: () => import('./views/SubCategories/SubCategories'),
  loading: Loading,
});

const AddSubCategory = Loadable({
  loader: () => import('./views/SubCategories/AddSubCategory'),
  loading: Loading,
});

const EditSubCategory = Loadable({
  loader: () => import('./views/SubCategories/EditSubCategory'),
  loading: Loading,
});

const DealerShelf = Loadable({
  loader: () => import('./views/DealerShelf/DealerShelf'),
  loading: Loading,
});

const AddDealerShelf = Loadable({
  loader: () => import('./views/DealerShelf/AddDealerShelf'),
  loading: Loading,
});

const EditDealerShelf = Loadable({
  loader: () => import('./views/DealerShelf/EditDealerShelf'),
  loading: Loading,
});

const Banners = Loadable({
  loader: () => import('./views/Banners/Banners'),
  loading: Loading,
});

const AddBanner = Loadable({
  loader: () => import('./views/Banners/AddBanner'),
  loading: Loading,
});

const EditBanner = Loadable({
  loader: () => import('./views/Banners/EditBanner'),
  loading: Loading,
});

const Advertisements = Loadable({
  loader: () => import('./views/Advertisements/Advertisements'),
  loading: Loading,
});

const AddAdvertisement = Loadable({
  loader: () => import('./views/Advertisements/AddAdvertisement'),
  loading: Loading,
});

const EditAdvertisement = Loadable({
  loader: () => import('./views/Advertisements/EditAdvertisement'),
  loading: Loading,
});

const ViewAdvertisement = Loadable({
  loader: () => import('./views/Advertisements/ViewAdvertisement'),
  loading: Loading,
});

const Users = Loadable({
  loader: () => import('./views/Users/Users'),
  loading: Loading,
});

const AddUser = Loadable({
  loader: () => import('./views/Users/AddUser'),
  loading: Loading,
});

const UserNotification = Loadable({
  loader: () => import('./views/Users/UserNotification'),
  loading: Loading,
});

const EditUser = Loadable({
  loader: () => import('./views/Users/EditUser'),
  loading: Loading,
});
const ViewUser = Loadable({
  loader: () => import('./views/Users/ViewUser'),
  loading: Loading,
});

const MainServices = Loadable({
  loader: () => import('./views/MainServices/MainServices'),
  loading: Loading,
});
const ImportMainServices = Loadable({
  loader: () => import('./views/MainServices/ImportService'),
  loading: Loading,
});
const ImportBrand = Loadable({
  loader: () => import('./views/CarBrand/ImportBrand'),
  loading: Loading,
});
const ImportModel = Loadable({
  loader: () => import('./views/CarModel/ImportModel'),
  loading: Loading,
});
const ImportServices = Loadable({
  loader: () => import('./views/Services/ImportService'),
  loading: Loading,
});
const ImportCategory = Loadable({
  loader: () => import('./views/Categories/ImportCategory'),
  loading: Loading,
});
const ImportSubCategory = Loadable({
  loader: () => import('./views/SubCategories/ImportSubCategory'),
  loading: Loading,
});
const ImportVariant = Loadable({
  loader: () => import('./views/CarVariant/ImportVariant'),
  loading: Loading,
});

const AddMainService = Loadable({
  loader: () => import('./views/MainServices/AddMainService'),
  loading: Loading,
});

const EditMainService = Loadable({
  loader: () => import('./views/MainServices/EditMainService'),
  loading: Loading,
});

const Services = Loadable({
  loader: () => import('./views/Services/Services'),
  loading: Loading,
});

const AddService = Loadable({
  loader: () => import('./views/Services/AddService'),
  loading: Loading,
});

const EditService = Loadable({
  loader: () => import('./views/Services/EditService'),
  loading: Loading,
});

const UserAddress = Loadable({
  loader: () => import('./views/Users/UserAddress'),
  loading: Loading,
});

const Stores = Loadable({
  loader: () => import('./views/Stores/Stores'),
  loading: Loading,
});

const AddStore = Loadable({
  loader: () => import('./views/Stores/AddStore'),
  loading: Loading,
});

const EditStore = Loadable({
  loader: () => import('./views/Stores/EditStore'),
  loading: Loading,
});
const ViewStore = Loadable({
  loader: () => import('./views/Stores/ViewStore'),
  loading: Loading,
});
const ChangePassword = Loadable({
  loader: () => import('./views/Stores/ChangePassword'),
  loading: Loading,
});

const SetTimeStors = Loadable({
  loader: () => import('./views/Stores/SetTimeStors'),
  loading: Loading,
});

const ProductInventory = Loadable({
  loader: () => import('./views/Stores/ProductInventory'),
  loading: Loading,
});

const Products = Loadable({
  loader: () => import('./views/Products/Products'),
  loading: Loading,
});

const AddProduct = Loadable({
  loader: () => import('./views/Products/AddProduct'),
  loading: Loading,
});

const EditProduct = Loadable({
  loader: () => import('./views/Products/EditProduct'),
  loading: Loading,
});

const ViewProduct = Loadable({
  loader: () => import('./views/Products/ViewProduct'),
  loading: Loading,
});

const PostCar = Loadable({
  loader: () => import('./views/Posts/PostCar'),
  loading: Loading,
});

const PostProduct = Loadable({
  loader: () => import('./views/Posts/PostProduct'),
  loading: Loading,
});

const AddPost = Loadable({
  loader: () => import('./views/Posts/AddPost'),
  loading: Loading,
});

const EditPost = Loadable({
  loader: () => import('./views/Posts/EditPost'),
  loading: Loading,
});

const DiscountCode = Loadable({
  loader: () => import('./views/DiscountCode/DiscountCode'),
  loading: Loading,
});

const AddDiscountCode = Loadable({
  loader: () => import('./views/DiscountCode/AddDiscountCode'),
  loading: Loading,
});

const ViewDiscountCode = Loadable({
  loader: () => import('./views/DiscountCode/ViewDiscountCode'),
  loading: Loading,
});

const Deliveryboys = Loadable({
  loader: () => import('./views/Deliveryboys/Deliveryboys'),
  loading: Loading,
});

const AddDeliveryboys = Loadable({
  loader: () => import('./views/Deliveryboys/AddDeliveryboys'),
  loading: Loading,
});
const EditDeliveryboys = Loadable({
  loader: () => import('./views/Deliveryboys/EditDeliveryboys'),
  loading: Loading,
});

const ViewDeliveryboys = Loadable({
  loader: () => import('./views/Deliveryboys/ViewDeliveryboys'),
  loading: Loading,
});


const EditDiscountCode = Loadable({
  loader: () => import('./views/DiscountCode/EditDiscountCode'),
  loading: Loading,
});
const AddProductImages = Loadable({
  loader: () => import('./views/Products/AddProductImages'),
  loading: Loading,
});

const Orders = Loadable({
  loader: () => import('./views/Orders/Orders'),
  loading: Loading,
});

const OrdersHistory = Loadable({
  loader: () => import('./views/Orders/OrdersHistory'),
  loading: Loading,
});

const UserOrdersHistory = Loadable({
  loader: () => import('./views/Orders/UserOrdersHistory'),
  loading: Loading,
});
const UserWalletHistory = Loadable({
  loader: () => import('./views/Users/UserWalletHistory'),
  loading: Loading,
});

const StoreOrdersHistory = Loadable({
  loader: () => import('./views/Orders/StoreOrdersHistory'),
  loading: Loading,
});

const DriverOrdersHistory = Loadable({
  loader: () => import('./views/Orders/DriverOrdersHistory'),
  loading: Loading,
});

const ViewOrder = Loadable({
  loader: () => import('./views/Orders/ViewOrder'),
  loading: Loading,
});

const ViewOrderHistory = Loadable({
  loader: () => import('./views/Orders/ViewOrderHistory'),
  loading: Loading,
});
const Settings = Loadable({
  loader: () => import('./views/Settings/Settings'),
  loading: Loading,
});
const DeliveryPrice = Loadable({
  loader: () => import('./views/DeliveryPrice/DeliveryPrice'),
  loading: Loading,
});

const CancelReasons = Loadable({
  loader: () => import('./views/CancelReasons/CancelReasons'),
  loading: Loading,
});

const Notifications = Loadable({
  loader: () => import('./views/Notifications/Notifications'),
  loading: Loading,
});

const AddNotification = Loadable({
  loader: () => import('./views/Notifications/AddNotification'),
  loading: Loading,
});

const ViewNotification = Loadable({
  loader: () => import('./views/Notifications/ViewNotification'),
  loading: Loading,
});

const Feature = Loadable({
  loader: () => import('./views/Feature/Feature'),
  loading: Loading,
});

const SoldProducts = Loadable({
  loader: () => import('./views/Sold/Products'),
  loading: Loading,
});

const SoldCars = Loadable({
  loader: () => import('./views/Sold/Cars'),
  loading: Loading,
});
const CarVariant = Loadable({
  loader: () => import('./views/CarVariant/CarVariant'),
  loading: Loading,
});
const AddCarVariant = Loadable({
  loader: () => import('./views/CarVariant/CarVariantModel'),
  loading: Loading,
});
const EditCarVariant = Loadable({
  loader: () => import('./views/CarVariant/EditCarVariant'),
  loading: Loading,
});
const Fuel = Loadable({
  loader: () => import('./views/Fuel/Fuel'),
  loading: Loading,
});
const AddFuel = Loadable({
  loader: () => import('./views/Fuel/AddFuel'),
  loading: Loading,
});
const EditFuel = Loadable({
  loader: () => import('./views/Fuel/EditFuel'),
  loading: Loading,
});

const routes = [
  { path: '/', exact: true, name: 'Home', component: DefaultLayout },
  { path: '/dashboard', name: 'Dashboard', component: Dashboard },
  { path: '/profile', name: 'Profile', component: Profile },

  { path: '/feature', exact: true, name: 'Feature', component: Feature },

  //Car Category Manager
  { path: '/car/categories', exact: true, name: 'Car Categories', component: CarCategories },
  { path: '/car/categories/add-category', exact: true, name: 'Add Category', component: AddCarCategory },
  { path: '/car/categories/edit-category', exact: true, name: 'Edit Category', component: EditCarCategory },

  //Car Brand Manager
  { path: '/car/brands', exact: true, name: 'Car Brand', component: CarBrands },
  { path: '/car/brands/add-brand', exact: true, name: 'Add Brand', component: AddCarBrand },
  { path: '/car/brands/edit-brand', exact: true, name: 'Edit Brand', component: EditCarBrand },
  { path: '/car/brands/import-brand', exact: true, name: 'Import Brand', component: ImportBrand },

  //Car Model Manager
  { path: '/car/models', exact: true, name: 'Car Model', component: CarModels },
  { path: '/car/models/add-model', exact: true, name: 'Add Model', component: AddCarModel },
  { path: '/car/models/edit-model', exact: true, name: 'Edit Model', component: EditCarModel },
  { path: '/car/models/import-model', exact: true, name: 'Import Model', component: ImportModel },


  //Car Variant Manager
  { path: '/car/variant', exact: true, name: 'Car Variant', component: CarVariant },
  { path: '/car/variant/add-variant', exact: true, name: 'Add Variant', component: AddCarVariant },
  { path: '/car/variant/edit-variant', exact: true, name: 'Edit Variant', component: EditCarVariant },
  { path: '/car/variant/import-variant', exact: true, name: 'Import Variant', component: ImportVariant },
  //Car Fuel Manager
  { path: '/fuel', exact: true, name: 'Car Fuel', component: Fuel },
  { path: '/fuel/add-fuel', exact: true, name: 'Add Fuel', component: AddFuel },
  { path: '/fuel/edit-fuel', exact: true, name: 'Edit Fuel', component: EditFuel },

  //Car Sell Manager
  { path: '/cars/sell', exact: true, name: 'Car Sell', component: CarSells },
  { path: '/cars/sell/view', exact: true, name: 'View', component: ViewCarSells },
  { path: '/cars/sell/add', exact: true, name: 'View', component: AddCarSells },
  { path: '/cars/sell/edit', exact: true, name: 'View', component: EditCarSells },
  { path: '/posts/viewCar', exact: true, name: 'View', component: ViewCarSellsData },

  //Car List Manager
  { path: '/cars', exact: true, name: 'Cars', component: CarLists },
  { path: '/cars/add-car', exact: true, name: 'Add Car', component: AddCar },
  { path: '/cars/edit-car', exact: true, name: 'Edit Car', component: EditCar },
  { path: '/cars/import-car', exact: true, name: 'Import Car', component: ImportCar },

  { path: '/cars/color', exact: true, name: 'Color', component: ColorList },
  { path: '/cars/color/add-color', exact: true, name: 'Add Color', component: AddColor },
  { path: '/cars/color/edit-color', exact: true, name: 'Edit Color', component: EditColor },

  //Content Page Routes
  { path: '/contents', exact: true, name: 'Contents', component: Contents },
  { path: '/contents/edit-content', exact: true, name: 'Edit Content', component: EditContent },

  //EmailTemplates Page Routes
  { path: '/email-templates', exact: true, name: 'Email Templates', component: EmailTemplates },
  { path: '/email-templates/edit-email-template', exact: true, name: 'Edit Email Template', component: EditEmailTemplate },
  { path: '/email-templates/view-email-template', exact: true, name: 'View Email Template', component: ViewEmailTemplate },

  //Category Page Routes 
  { path: '/items/categories', exact: true, name: 'Categories', component: Categories },
  { path: '/items/categories/add-category', exact: true, name: 'Add Category', component: AddCategory },
  { path: '/items/categories/edit-category', exact: true, name: 'Edit Category', component: EditCategory },
  { path: '/items/categories/import-category', exact: true, name: 'Import Category', component: ImportCategory },

  //Category Page Routes 
  { path: '/items/occasions', exact: true, name: 'Occasions', component: Occasions },
  { path: '/items/occasions/add-occasion', exact: true, name: 'Add Occasion', component: AddOccasion },
  { path: '/items/occasions/edit-occasion', exact: true, name: 'Edit Occasion', component: EditOccasion },


  //Sub Category Page Routes 
  { path: '/items/sub-categories', exact: true, name: 'Sub Categories', component: SubCategories },
  { path: '/items/sub-categories/add-sub-category', exact: true, name: 'Add Sub Category', component: AddSubCategory },
  { path: '/items/sub-categories/edit-sub-category', exact: true, name: 'Edit Sub Category', component: EditSubCategory },
  { path: '/items/sub-categories/import-sub-categories', exact: true, name: 'Import Sub Category', component: ImportSubCategory },

  //Dealer Shelf Page Routes 
  { path: '/dealer/shelf', exact: true, name: 'Dealer Shelf', component: DealerShelf },
  { path: '/dealer/shelf/add-dealer-shelf', exact: true, name: 'Add Dealer Shelf', component: AddDealerShelf },
  { path: '/dealer/shelf/edit-dealer-shelf', exact: true, name: 'Edit Dealer Shelf', component: EditDealerShelf },


  //Banners Page Routes 
  { path: '/banners', exact: true, name: 'Banners', component: Banners },
  { path: '/banners/add-banner', exact: true, name: 'Add Banner', component: AddBanner },
  { path: '/banners/edit-banner', exact: true, name: 'Edit Banner', component: EditBanner },

  //Advertisements Page Routes 
  { path: '/advertisements', exact: true, name: 'Advertisements', component: Advertisements },
  { path: '/advertisements/add-advertisement', exact: true, name: 'Add Advertisement', component: AddAdvertisement },
  { path: '/advertisements/edit-advertisement', exact: true, name: 'Edit Advertisement', component: EditAdvertisement },
  { path: '/advertisements/view-advertisement', exact: true, name: 'View Advertisement', component: ViewAdvertisement },

  // Users Page Routes
  { path: '/users', exact: true, name: 'Users', component: Users },
  { path: '/users/add-user', exact: true, name: 'Add User', component: AddUser },
  { path: '/users/edit-user', exact: true, name: 'Edit User', component: EditUser },
  { path: '/users/view-user', exact: true, name: 'View User', component: ViewUser },
  { path: '/users/user-addresses', exact: true, name: 'View User Addresses', component: UserAddress },
  { path: '/users/send-notification', exact: true, name: 'Send User Notification', component: UserNotification },

  // Main Service Page Routes
  { path: '/main_services', exact: true, name: 'Main Services', component: MainServices },
  { path: '/main_services/add-service', exact: true, name: 'Add Main Service', component: AddMainService },
  { path: '/main_services/edit-service', exact: true, name: 'Edit Main Service', component: EditMainService },
  { path: '/main_services/import-service', exact: true, name: 'Import Main Service', component: ImportMainServices },
  // Service Page Routes
  { path: '/services', exact: true, name: 'Services', component: Services },
  { path: '/services/add-service', exact: true, name: 'Add Service', component: AddService },
  { path: '/services/edit-service', exact: true, name: 'Edit Service', component: EditService },
  { path: '/services/import-service', exact: true, name: 'Import Service', component: ImportServices },

  // Stores Page Routes
  { path: '/stores', exact: true, name: 'Branchs', component: Stores },
  { path: '/stores/add-store', exact: true, name: 'Add Branch', component: AddStore },
  { path: '/stores/edit-store', exact: true, name: 'Edit Branch', component: EditStore },
  { path: '/stores/change-password', exact: true, name: 'Change Password', component: ChangePassword },
  { path: '/stores/view-store', exact: true, name: 'View Branch', component: ViewStore },

  // Products Page Routes
  { path: '/items/products', exact: true, name: 'Products', component: Products },
  { path: '/items/products/add-product', exact: true, name: 'Add Product', component: AddProduct },
  { path: '/items/products/edit-product', exact: true, name: 'Edit Product', component: EditProduct },
  { path: '/items/products/view-product', exact: true, name: 'View Product', component: ViewProduct },

  // Products Page Routes
  { path: '/items/products/sell', exact: true, name: 'Sell Products', component: SellProducts },
  { path: '/items/products/sell/view', exact: true, name: 'View', component: ViewSellProducts },
  { path: '/products/sell/add', exact: true, name: 'View', component: AddProductseller },
  { path: '/products/sell/edit', exact: true, name: 'View', component: EditSellProduct },
  { path: '/items/products/import-product', exact: true, name: 'Import Product', component: ImportProduct },

  // Post Page Routes
  { path: '/posts/product', exact: true, name: 'Posts', component: PostProduct },
  { path: '/posts/data', exact: true, name: 'Car Post', component: PostCar },
  { path: '/posts/add-post', exact: true, name: 'Add Post', component: AddPost },
  { path: '/posts/edit-post', exact: true, name: 'Edit Post', component: EditPost },

  //Product Images Page Routes
  { path: '/items/products/add-product-images', exact: true, name: 'Add Product Images', component: AddProductImages },

  // Discount Code Page Routes
  { path: '/discount-code', exact: true, name: 'Coupon Code', component: DiscountCode },
  { path: '/discount-code/add-discount-code', exact: true, name: 'Add Coupon Code', component: AddDiscountCode },
  { path: '/discount-code/edit-discount-code', exact: true, name: 'Edit Coupon Code', component: EditDiscountCode },
  { path: '/discount-code/view-discount-code', exact: true, name: 'View Coupon Code', component: ViewDiscountCode },

  // Driver Page Routes
  { path: '/delivery-boys', exact: true, name: 'Delivery boys', component: Deliveryboys },
  { path: '/delivery-boys/add-delivery-boy', exact: true, name: 'Add Delivery boy', component: AddDeliveryboys },
  { path: '/delivery-boys/edit-delivery-boy', exact: true, name: 'Edit Delivery boy', component: EditDeliveryboys },
  { path: '/delivery-boys/view-delivery-boy', exact: true, name: 'View Delivery boy', component: ViewDeliveryboys },


  // Order Page Routes
  { path: '/orders/list', exact: true, name: 'Orders', component: Orders },
  { path: '/orders/history', exact: true, name: 'Order History', component: OrdersHistory },
  { path: '/users/user-order-history/:userId', exact: true, name: 'Order History', component: UserOrdersHistory },
  { path: '/users/user-wallet-history/:userId', exact: true, name: 'Wallet History', component: UserWalletHistory },

  { path: '/stores/store-order-history/:storeId', exact: true, name: 'Order History', component: StoreOrdersHistory },
  { path: '/delivery-boys/delivery-boys-order-history/:driverId', exact: true, name: 'Order History', component: DriverOrdersHistory },
  { path: '/orders/view', exact: true, name: 'View Order', component: ViewOrder },
  { path: '/orders/view-order', exact: true, name: 'View Order', component: ViewOrderHistory },
  //Settings Page Routes
  { path: '/settings', name: 'Settings', component: Settings },
  { path: '/delivery-price', name: 'Delivery Price Manager', component: DeliveryPrice },


  // Cancel Reasons  Page Routes
  { path: '/cancel-reasons', exact: true, name: 'Cancel Reasons', component: CancelReasons },
  //Notification Request Page Routes
  { path: '/notifications', exact: true, name: 'Notifications Manager', component: Notifications },
  { path: '/add-notification', exact: true, name: 'Add Notification', component: AddNotification },
  { path: '/notifications/view-notification', exact: true, name: 'View Notification', component: ViewNotification },


  // Products Page Routes
  { path: '/sold/products/', exact: true, name: 'Sold Products', component: SoldProducts },
  { path: '/sold/data/', exact: true, name: 'Sold Cars', component: SoldCars },




];

export default routes;
